import { message } from "antd";
import { useLanguage } from "../context/LanguageContext";
import messageTranslations from "../utils/messageContent";

const useFeedbackFormService = () => {
  const { language } = useLanguage();
  const t = messageTranslations[language] || messageTranslations["de"];

  const createFeedbackForm = async (payload) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/feedbackform/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(
          t.feedbackForm?.createError || "Erstellung fehlgeschlagen."
        );
      }

      const data = await response.json();
      message.success(t.feedbackForm?.createSuccess || "Formular erstellt!");
      return data;
    } catch (error) {
      console.error("Create Error:", error.message);
      message.error(error.message);
      return null;
    }
  };

  const getFeedbackForms = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/feedbackform/list`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(t.feedbackForm?.loadListError);
      }

      const data = await response.json();
      return data.feedbackForms;
    } catch (error) {
      console.error("List Error:", error.message);
      return [];
    }
  };

  const getFeedbackFormById = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/feedbackform/${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(t.feedbackForm?.loadSingleError);
      }

      const data = await response.json();
      return data.feedbackForm;
    } catch (error) {
      console.error("Get by ID Error:", error.message);
      message.error(t.feedbackForm?.loadSingleError);
      return null;
    }
  };

  const deleteFeedbackForm = async (id) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/feedbackform/delete`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({ id }),
        }
      );

      if (!response.ok) {
        throw new Error(t.feedbackForm?.deleteError);
      }

      message.success(t.feedbackForm?.deleteSuccess);
      return true;
    } catch (error) {
      console.error("Delete Error:", error.message);
      message.error(t.feedbackForm?.deleteError);
      return false;
    }
  };

  const updateFeedbackForm = async (id, payload) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/feedbackform/update`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          body: JSON.stringify({ payload, id }),
        }
      );

      if (!response.ok) {
        throw new Error(t.feedbackForm?.updateError);
      }

      const data = await response.json();
      message.success(t.feedbackForm?.updateSuccess);
      return data.feedbackForm;
    } catch (error) {
      console.error("Update Error:", error.message);
      message.error(t.feedbackForm?.updateError);
      return null;
    }
  };

  const getExampleForm = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/feedbackform/getExampleForm`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          t.feedbackForm?.loadSingleError ||
            "Fehler beim Laden des Beispiel-Formulars."
        );
      }

      const data = await response.json();
      return data.feedbackForm;
    } catch (error) {
      console.error("Get Example Form Error:", error.message);
      message.error(
        t.feedbackForm?.loadSingleError ||
          "Fehler beim Laden des Beispiel-Formulars."
      );
      return null;
    }
  };

  return {
    createFeedbackForm,
    getFeedbackForms,
    getFeedbackFormById,
    deleteFeedbackForm,
    updateFeedbackForm,
    getExampleForm,
  };
};

export default useFeedbackFormService;
